import logo from './logo.svg';
import './App.css';
import { Component } from 'react';
import  Home from './pages/Home' 
import { BrowserRouter, Routes, Route ,useLocation  } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Contact from "./components/Contact";
import OrderForm from "./Customer/OrderForm";
import '@fortawesome/fontawesome-free/css/all.min.css';
import LoginAdmin from "./components/LoginAdmin";
import LoginCustomer from "./Customer/Login";
import NavbarHandler from './components/NavbarHandler'
// import Login from "./components/Login";
// import CustomerList from './Admin/customers/CustomerList';
// import CustomerForm from './Admin/customers/CustomerForm';
// import CustomerManagement from './Admin/customers/CustomerManagement';
import CustomerRoutes from './Customer/CustomerRoutes'
import AdminRoutes  from './Admin/AdminRoutes';
// import OrderList from './Customer/OrderList';
import PrivateRoute from "./components/PrivateRoute";
import NotFound   from  "./pages/NotFound"
import  HomeCustomer from './Customer/HomeCustomer'
import PrivateRouteAdmin from './components/PrivateRouteAdmin'
function App() {
  return (
    <div className="App">
<BrowserRouter>
  <NavbarHandler />
  <Routes>
    {/* Public Pages */}
    <Route path="/" element={<Home />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/login" element={<LoginCustomer />} />
    <Route path="/login_admin" element={<LoginAdmin />} />

   

      {/* Customer Routes - protected */}
      <Route path="/customer/*" element={<PrivateRoute />}>
      <Route path="*" element={<CustomerRoutes />} />
    </Route>

    {/* Admin Area */}
    <Route path="/admin/*" element={<PrivateRouteAdmin />}>
      <Route path="*" element={<AdminRoutes />} />
    </Route>

    {/* Catch-all 404 */}
    <Route path="*" element={<NotFound />} />
  </Routes>
</BrowserRouter>
    </div>
  );
}

export default App;

